import { render } from "./ModalAddUpdateCustomer.vue?vue&type=template&id=32830938"
import script from "./ModalAddUpdateCustomer.vue?vue&type=script&lang=js"
export * from "./ModalAddUpdateCustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__